import { render, staticRenderFns } from "./OptimizeMediaMetadata.vue?vue&type=template&id=f98f2a0a&scoped=true&"
import script from "./OptimizeMediaMetadata.vue?vue&type=script&lang=js&"
export * from "./OptimizeMediaMetadata.vue?vue&type=script&lang=js&"
import style0 from "./OptimizeMediaMetadata.vue?vue&type=style&index=0&id=f98f2a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98f2a0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VSimpleTable})
